import React from 'react'

// css
import 'assets/style/elements/rate.scss'

function Rate({ className = '', max = 5, rate = 0, onClick = () => {} }) {
  return (
    <div className={`rate-box ` + className}>
      {[...Array(5)].map((x, i) => (
        <span key={i} className={`star ${rate >= i + 1 ? 'active' : ''}`} onClick={() => onClick(i)}>
          별
        </span>
      ))}
    </div>
  )
}

export default Rate
